<template>
    <div class="liked-card">
        <div class="liked-card-img">
            <img :src="require('@/assets/img_site/slide2_main.svg')" alt="">

        </div>
        <div class="liked-card-title">Xiaomi Mi Notebook Pro 2019</div>
        <button>Купить</button>
        <div class="liked-card-remove">
            <x-circle-icon size="1x" class="custom-class"></x-circle-icon>
        </div>
    </div>
</template>

<script>
    import { XCircleIcon } from 'vue-feather-icons'
    export default {
        name: "LikedProductCard",
        components: {
            XCircleIcon
        }
    }
</script>

<style scoped lang="scss">
    .liked-card {
        display: flex;
        align-items: center;
        max-height: 88px;
        width: 100%;
        padding: 26px 16px;
        &-img {
            max-width: 60px;
            max-height: 30px;
            margin-right: 15px;
            img {
                height: 100%;
                width: 100%;
            }
        }
        &-title {
            color: #3F4450;
            font-size: 14px;
            line-height: 21px;
            margin-right: 10px;
        }
        &-remove {
            margin-left: 8px;
            cursor: pointer;
            svg {
                color: #C6CED7;
            }
        }
        button {
            background: linear-gradient(80.98deg, #7AC3C1 0%, #3FB0AB 100%);
            border: none;
            border-radius: 5px;
            color: #FCFCFC;
            font-size: 16px;
            padding: 8px 24px;
            cursor: pointer;
        }
    }

</style>